import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const CampaignWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${props => props.campaignColor};
  padding: 8px;
`;
